import React, { lazy } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/UI/Button';
export const speakersData = {
  'andrew-igbineweka': {
    name: 'Andrew Igbineweka',
    title: 'Founder, The Networking Salon',
    role: 'Founder, The Networking Salon',
    image: 'https://cdn.magicpatterns.com/uploads/fwaGuwXSUvXgr3kXBfGv8a/Andrew_Igbineweka,_Founder_.jpg',
    bio: `Andrew Igbineweka is the Founder of The Networking Salon — a professional networking community that helps people connect intentionally, grow meaningful relationships, and build careers with purpose. 

He believes that everyone deserves access to the rooms, mentors, and conversations that move their lives forward. Under his leadership, The Networking Salon has become a home for educators, professionals, students, and changemakers across multiple cities — building bridges between people, ideas, and opportunity.

Andrew is hosting The Sustainability Networking Salon as part of The Networking Salon's commitment to creating clear, accessible pathways into the careers shaping the future.`
  },
  'bella-ojoka': {
    name: 'Bella Ojoka',
    title: 'Host & Convener',
    role: 'Sustainability Professional',
    image: 'https://cdn.magicpatterns.com/uploads/aUFAXyPFx2uJcbCVTVK4JN/Bella_Ojoka,_Sustainability_Professional.jpg',
    bio: `Bella Ojoka is a Sustainability Professional and the Host and Convener of The Sustainability Networking Salon. She is passionate about creating ecosystems where aspiring and established professionals can connect, learn, and grow. With a deep commitment to environmental stewardship and social impact, Bella bridges the gap between learning and real-world practice, helping individuals navigate their career pathways in sustainability with clarity and purpose.`
  },
  'sunday-ojo': {
    name: 'Sunday Ojo',
    title: 'Speaker',
    role: 'Sustainability/ESG Professional',
    image: 'https://cdn.magicpatterns.com/uploads/n8FSEHbzLcNgPm2mWvP1pU/Sunday_Ojo,_Sustainability_-_ESG_professional.jpg',
    bio: `Sunday Ojo is a Sustainability/ESG professional with a focus on climate change analysis, GHG emissions inventory/estimation, carbon accounting, air dispersion modelling and Geospatial analysis. He has acquired over 8 years' experience across Africa, in the execution of technical, strategic, scientific, socio-economic and impacts related projects for policy and decision making in the public and private sector. 

His most recent research interests are centred around digital transformation involving environmental data, climate change modelling, and impact assessment. Sunday Ojo has assisted and influenced businesses in achieving sustainability by guaranteeing the "climate-proofing" of their investments and growth initiatives. 

As part of his work, he has developed and implemented sustainability programs for a variety of organizations, and has conducted several environmental impact and climate risks assessments. He also supports the scientific community as a climatologist by conducting studies that tackle important problems pertaining to the impact of climate variability on ecosystems and human cultures.`
  },
  'caleb-joshua': {
    name: 'Caleb Halal Joshua',
    title: 'Speaker',
    role: 'Environmental Analyst, NNPC Energy Services Ltd.',
    image: 'https://cdn.magicpatterns.com/uploads/e6eTkhxMX3uYMf4sQVnfVc/Caleb_Joshua,_Environmental_Analyst,_NNPC_Energy_Services_Ltd..jpg',
    bio: `Environmental Analyst with over six years of professional experience at NNPC Ltd, with expertise in environmental impact assessments, regulatory compliance, and sustainable waste management practices in the oil and gas industry. 

Holds a Master's degree in Environmental Quality Management and is currently pursuing a Ph.D in the same field, working on a novel study on emerging high impact pollutants around in-land rivers in Benin City. 

Passionate about promoting environmental stewardship and data-driven solutions that support environmental protection and sustainability.`
  },
  'ozioma-chinedu': {
    name: 'Ozioma Chinedu',
    title: 'Speaker',
    role: 'Sustainability Professional',
    image: 'https://cdn.magicpatterns.com/uploads/v5ZmLHkkY9CgngtLHLxhSv/Ozioma_Chinedu,_Sustainability_Professional.jpg',
    bio: `Ozioma Chinedu is an experienced sustainability consultant with over six years of experience in sustainability reporting, GHG accounting, environmental compliance monitoring, and environmental management systems. She combines rigorous scientific knowledge with strong advisory experience across the financial, energy, oil and gas, infrastructure, real estate, and utilities sectors.

She currently works as a consultant at Aqua Earth Consulting and has led the development of sustainability reports aligned with globally recognized frameworks including GRI, CDP, SASB, NGX SDGs and NSBP.

Beyond reporting and technical work, she has delivered sustainability trainings to participants across multiple sectors, accumulating over 300 training hours. Through these training sessions, professionals gain both strategic understanding and practical processes to consistently apply sustainability principles across their daily responsibilities.`
  }
};
export const GreenSpeakerDetail = () => {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const speaker = id ? speakersData[id as keyof typeof speakersData] : null;
  if (!speaker) {
    return <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4" data-id="element-3189" data-mp="3ju5spd4qk2i9">
        <h1 className="text-2xl font-bold text-navy mb-4" data-id="element-3190" data-mp="2dfkwakz7jcl">Speaker not found</h1>
        <Link to="/green" data-id="element-3191" data-mp="3tk8kxb419cfj">
          <Button variant="outline" data-id="element-3192" data-mp="3tm33wjvquugz">Return to Event Page</Button>
        </Link>
      </div>;
  }
  return <div className="min-h-screen bg-gray-50 py-12 md:py-20" data-id="element-3193" data-mp="bforipd4iskp">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-3194" data-mp="6gkj40y0wyvf">
        <Link to="/green" className="inline-flex items-center min-h-[44px] text-navy hover:text-secondary font-semibold mb-6 sm:mb-8 transition-colors group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 rounded" data-id="element-3195" data-mp="6dzi1e5jumyq">
          <ArrowLeft size={20} className="mr-2 transition-transform group-hover:-translate-x-1" aria-hidden="true" data-id="element-3196" data-mp="396m6kpwdprw2" />
          Back to Event Page
        </Link>

        <div className="bg-white rounded-2xl sm:rounded-3xl shadow-xl overflow-hidden border border-gray-100" data-id="element-3197" data-mp="3j0w8ozb4i4jz">
          <div className="md:flex" data-id="element-3198" data-mp="3swptt72wr6dd">
            <div className="md:w-2/5 relative aspect-[4/5] md:aspect-auto md:h-auto bg-navy" data-id="element-3199" data-mp="3sxr6ffzko0x7">
              <img src={speaker.image} alt={`${speaker.name}, ${speaker.role}`} className="absolute inset-0 w-full h-full object-cover object-top" loading="lazy" data-id="element-3200" data-mp="t6qz0jesmuh" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent md:bg-gradient-to-r md:from-transparent md:to-navy/0" aria-hidden="true" data-id="element-3201" data-mp="22mctyghxc6mx"></div>
              <div className="absolute bottom-4 left-4 md:hidden" data-id="element-3202" data-mp="1laxsldj61qio">
                <span className="inline-block bg-gold text-navy px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider" data-id="element-3203" data-mp="1lb7kj6nru7r0">
                  {speaker.title}
                </span>
              </div>
            </div>

            <div className="md:w-3/5 p-8 md:p-12 lg:p-16" data-id="element-3204" data-mp="2dx943j8b9bu9">
              <div className="hidden md:inline-block bg-gold text-navy px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-3205" data-mp="291tpuq6e5dxb">
                {speaker.title}
              </div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-3 font-heading" data-id="element-3206" data-mp="1zz2f6slcam6q">
                {speaker.name}
              </h1>
              <p className="text-lg text-secondary font-semibold mb-8 pb-8 border-b-2 border-gray-100" data-id="element-3207" data-mp="okox64d9p0ym">
                {speaker.role}
              </p>

              <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed whitespace-pre-wrap" data-id="element-3208" data-mp="2oldb1xy8pchl">
                {speaker.bio}
              </div>

              <div className="mt-10 pt-8 border-t-2 border-gray-100" data-id="element-3209" data-mp="2epa8ws3e1dun">
                <Link to="/green" data-id="element-3210" data-mp="2er3j2hd7mg7e">
                  <Button variant="outline" data-id="element-3211" data-mp="2jn20tm418zyu">
                    <ArrowLeft size={18} className="mr-2" data-id="element-3212" data-mp="2jo3lmiaup0tr" />
                    Back to Event Page
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};